import { render, staticRenderFns } from "./IntermediaryTypeHelpList2.vue?vue&type=template&id=355c11e9&"
import script from "./IntermediaryTypeHelpList2.vue?vue&type=script&lang=js&"
export * from "./IntermediaryTypeHelpList2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports